export default class Webhook {
    id: string;
    name: string;
    enabled: boolean;
    eventType: string;
    url: string;
    createdAt: number;
}